import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NumericOperationManager } from 'src/app/common/utils/numeric-operation-manager';
import { PropertiesSettings } from "src/app/core/configuration/properties-settings";
import { HelpersService } from "src/app/core/services/helpers.service";
import { OperationsService } from "src/app/core/services/operations.service";
import { LegaleIncaricatoAdapter } from "../models/dto/legale-incaricato-adapter";
import { Legale } from "../models/legale";
import { LegaleIncaricato } from "../models/legale-incaricato";
import { TariffaLegale, TariffaLegaleIncaricato } from "../models/tariffa";
import { Categoria } from "../models/tipologiche/categoria";
import { Cpa } from "../models/tipologiche/cpa";
import { Iva } from "../models/tipologiche/iva";
import { BaseForm } from "./base-Form";


declare var removeEmptyObject: any;


export abstract class AssociativaLegaliForm extends BaseForm {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  categorie: Categoria[] = [];
  associativaForm: FormGroup;
  formLegaleIncaricato: LegaleIncaricato;
  legale: Legale;
  type: string;
  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
    this.helpers.getCpa().subscribe(response => this.cpaOptions = response);
    this.helpers.getIva().subscribe(response => this.ivaOptions = response);
  }

  tariffaSel: TariffaLegaleIncaricato;
  tariffe: { selected: boolean, tariffa: TariffaLegaleIncaricato }[] = [];
  riepilogo = false;
  cpaOptions: Cpa[] = [];
  ivaOptions: Iva[] = [];
  isModifica = false;

  createForm() {
    this.isModifica = false;
    this.tariffaSel = null;
    this.riepilogo = false
    let legaleIncaricato: LegaleIncaricato = this.getLegaleIncaricato();
    if (this.legale) {
      legaleIncaricato.legale = this.legale;

    }
    this.formLegaleIncaricato = new LegaleIncaricatoAdapter(
      legaleIncaricato
    ).legaleIncaricato;
    this.operationService.getTariffeLegale(this.formLegaleIncaricato.legale.id).subscribe((tariffe: TariffaLegale[]) =>
      this.tariffe = tariffe.map(tariffa => {
        const tariffaRevisionate = this.formLegaleIncaricato.tariffeRevisionate
          .find(_ => _.tariffaOriginale.id === tariffa.id);
        return {
          selected: !!tariffaRevisionate, tariffa: tariffaRevisionate ? tariffaRevisionate : TariffaLegaleIncaricato.fromTariffaLegale(tariffa)
        }
      }))
    if (!this.formLegaleIncaricato.dataAssociazione) {
      this.formLegaleIncaricato.dataAssociazione = new Date().getTime();
    }
    this.associativaForm = this.campiForm.group({
      dataInizioIncarico: [
        this.formLegaleIncaricato.dataInizioIncarico,
      ],
      principale: [this.formLegaleIncaricato.principale],
      revocato: [this.formLegaleIncaricato.revocato],
      dataRevoca: [this.formLegaleIncaricato.dataRevoca],
      //dataAssociazione: [this.formLegaleIncaricato.dataAssociazione, Validators.required],
      compensoPattuito: [this.formLegaleIncaricato.compensoPattuito, Validators.max(PropertiesSettings.MAX_VALUE_DECIMAL)],
      note: [this.formLegaleIncaricato.note],
      categoriaLegaleIncaricato: [
        this.formLegaleIncaricato.categoriaLegaleIncaricato,
        Validators.required,
      ],
    });
  }

  populateSelect() {
    if (this.categorie.length === 0) {
      this.helpers.getCategorieLegaleIncaricato().subscribe(response => this.categorie = response);
    }
  }

  update() {
    this.formLegaleIncaricato.tariffeRevisionate = this.tariffe.filter(_ => _.selected).map(_ => _.tariffa)
    this.getRequest(this.formLegaleIncaricato);
  }

  setLegale(legale: Legale) {
    this.legale = legale;
  }

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  changeFlag() {
    // this.tariffaSel.iva = this.flagIVA ? this.ivaOptions.find(el => el.valore === 22) : null;
    // this.tariffaSel.cpa = this.flagCPA ? this.cpaOptions.find(el => el.valore === 4) : null;
  }

  salvaTariffa() {
    this.tariffaSel.totaleSpese = this.totaleTariffa;
    this.tariffaSel.revisionata = this.tariffaSel.totaleSpese !== this.tariffaSel.tariffaOriginale.totaleSpese
    this.tariffaSel = null
    this.riepilogo = false
  }

  ripristinaTariffaOriginale() {
    this.tariffaSel.attivita = this.tariffaSel.tariffaOriginale.attivita
    this.tariffaSel.grado = this.tariffaSel.tariffaOriginale.grado
    this.tariffaSel.iva = this.tariffaSel.tariffaOriginale.iva
    this.tariffaSel.cpa = this.tariffaSel.tariffaOriginale.cpa
    this.tariffaSel.imponibile = this.tariffaSel.tariffaOriginale.imponibile
    this.tariffaSel.speseGenerali = this.tariffaSel.tariffaOriginale.speseGenerali
    this.tariffaSel.speseEsenti = this.tariffaSel.tariffaOriginale.speseEsenti
    this.tariffaSel.spesePiePagina = this.tariffaSel.tariffaOriginale.spesePiePagina
    this.tariffaSel.maggiorazione = this.tariffaSel.tariffaOriginale.maggiorazione
    this.tariffaSel.totaleSpese = this.tariffaSel.tariffaOriginale.totaleSpese
    this.tariffaSel.revisionata = this.tariffaSel.tariffaOriginale.revisionata
  }

  get totaleTariffa() {
    //let maggiorazione = this.tariffaSel.maggiorazione ? this.tariffaSel.maggiorazione : 0;
    let speseEsenti = this.tariffaSel.speseEsenti ? this.tariffaSel.speseEsenti : 0;
    let totale = this.totaleImponibile + speseEsenti;
    if (this.tariffaSel.iva) {
      totale += this.totaleImponibile * this.tariffaSel.iva.valore / 100;
    }
    return totale;
  }

  get totaleCompensi(){
    let totale = 0
    totale = this.tariffaSel.imponibile + this.maggiorazioneCalc
    return totale;
  }

  get cpaCalc() {
    let cpa
    let spesePieDiLista = this.tariffaSel.spesePiePagina ? this.tariffaSel.spesePiePagina : 0
      if(this.tariffaSel.cpa)
        //cpa = (this.speseGenerali + this.tariffaSel.imponibile + spesePieDiLista) * (this.tariffaSel.cpa.valore / 100);
        cpa = this.totaleCompensi * this.tariffaSel.cpa.valore / 100;
        else
            cpa = 0
    return cpa
  }

  get speseGenerali(){
    let speseGenerali
      if(this.tariffaSel.speseGenerali)
        speseGenerali = this.totaleCompensi * this.tariffaSel.speseGenerali / 100;
        else speseGenerali = 0
    return speseGenerali
  }

  get totaleImponibile() {
    let spesePieDiLista = this.tariffaSel.spesePiePagina ? this.tariffaSel.spesePiePagina : 0
    let totaleImponibile = this.totaleCompensi + this.speseGenerali + this.cpaCalc + spesePieDiLista;
    return totaleImponibile;
  }

  get maggiorazioneCalc(){
      let maggiorazione = 0;
      if(this.tariffaSel.imponibile && this.tariffaSel.maggiorazione){
          maggiorazione = this.tariffaSel.imponibile * this.tariffaSel.maggiorazione / 100
      }
      return maggiorazione
  }

  abstract getLegaleIncaricato(): LegaleIncaricato;
  abstract getRequest(request: LegaleIncaricato);
  abstract canCheckPrimary(): boolean;

}
